module.exports = __webpack_public_path__ + "static/quest_for_life-cc4555268a568f6e7a026de64a55857f.png";